import styled, { css } from 'react-emotion';
import theme from '@lyearn-team/theme-config';

export const FindImage = styled.div`
  text-align: center;
  .logoImage {
    width: 128px;
    height: 128px;
  }
  @media (max-width: 767px) {
    .logoImage {
      width: 128px;
      height: 128px;
    }
`;

export const DarkFindOrganizationWrapper = css`
  @media (min-width: 767px) {
    margin-top: auto;
  }
  @media (max-width: 767px) {
    margin-top: 100px;
  }
`;

export const InnerText = styled.div`
  font-size: 18px;
  color: ${theme.color.dark.iron};
  text-align: center;
  padding: 10px 0 0 20px;

  @media (max-width: 767px) {
    width: 330px;
    font-size: 14px;
    padding: 5px 0 0 0;
    text-align: center;
  }
`;
export const FindYourOrganizationHeading = css`
  margin-top: 10px;
  text-align: center;
`;
